import React from "react";
import { DatePicker } from "antd";
import { Typography } from "@mui/material";
import { DatePickerStyled } from "./date-picker.styles";
import { datePickerProps } from "./date-picker.type";
import dayjs from "dayjs";
import InfoIcon from "../../info-icon/info-icon";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";

const DateTimePickerField = (props) => {
  const {
    value,
    onChange,
    placeholder = "Enter Date",
    name,
    format = "MM-DD-YYYY",
    size = "small",
    status,
    defaultValue = null,
    label,
    isRequired,
    disableFn,
    disabled,
    description,
  } = props;

  const getdisabledFn = (current) => {
    if (disableFn === "past")
      return current.isBefore(dayjs().subtract(1, "day"));

    if (disableFn === "future") return current.isBefore(dayjs().add(1, "day"));
  };

  return (
    <DatePickerStyled>
      {label && (
        <Typography
          variant="body1"
          className="label"
          style={{ marginBottom: "8px" }}
        >
          {label}
          {isRequired && "*"}
          {description && <InfoIcon message={description} />}
        </Typography>
      )}

      <DatePicker
        key={name}
        value={value ? dayjs(value) : null}
        format={format}
        onChange={onChange}
        size={size}
        status={status}
        defaultValue={defaultValue}
        style={{
          width: size === "max" ? "100%" : "",
          height: "36px",
          borderColor: "#080425",
          borderRadius: "4px",
        }}
        placeholder={placeholder}
        disabledDate={(current) => getdisabledFn(current)}
        disabled={disabled}
        suffixIcon={
          <CalendarMonthOutlinedIcon
            style={{ color: "#545f71", fontWeight: "300", fontSize: "20px" }}
          />
        }
      />
    </DatePickerStyled>
  );
};

DateTimePickerField.propTypes = datePickerProps;

export default React.memo(DateTimePickerField);
